<form [formGroup]="profileForm" (ngSubmit)="updateProfile()">
  <h2 class="text-center text-primary">Your profile</h2>
  <hr>
    <label for="companyName">Name Company:</label>
    <input formControlName="companyName" type="text" class="form-control mx-2">
    <label for="contact">Contact:</label>
    <input formControlName="contact" type="text" class="form-control mx-2">
    <label for="address">Address:</label>
    <input formControlName="address" type="text" class="form-control mx-2">
    <label for="address2">Address 2:</label>
    <input formControlName="address2" type="text" class="form-control mx-2">
    <label for="zipcode">Zipcode:</label>
    <input formControlName="zipcode" type="text" class="form-control mx-2">
    <label for="city">City:</label>
    <input formControlName="city" type="text" class="form-control mx-2">
    <label for="country">Country:</label>
    <input formControlName="country" type="text" class="form-control mx-2">
    <label for="vatNumber">VAT Number:</label>
    <input formControlName="vatNumber" type="text" class="form-control mx-2">

    @if (validationErrors.length > 0) {
      <div class="row">
        <ul class="text-danger">
          @for (error of validationErrors; track error) {
            <li>
              {{error}}
            </li>
          }
        </ul>
      </div>
    }

    <div class="form-group text-center">
      <button [disabled]="!profileForm.dirty" class="btn btn-success mr-2" type="submit">Save</button>
    </div>
  </form>
